import { useTranslation } from 'react-i18next';

export const CRYPTO_CURRENCY_OPTIONS = [
  { id: 'btc', symbol: 'BTC', icon: '/icons/crypto/Bitcoin.svg', nameKey: 'btc', networkKey: 'bitcoin', accent: '#F7931A' },
  { id: 'eth', symbol: 'ETH', icon: '/icons/crypto/ethereum-eth.svg', nameKey: 'eth', networkKey: 'ethereum', accent: '#627EEA' },
  { id: 'usdt_trc20', symbol: 'USDT', icon: '/icons/crypto/tether.svg', nameKey: 'usdt', networkKey: 'trc20', accent: '#50AF95' },
  { id: 'usdt_bep20', symbol: 'USDT', icon: '/icons/crypto/tether.svg', nameKey: 'usdt', networkKey: 'bep20', accent: '#50AF95' },
  { id: 'usdt_erc20', symbol: 'USDT', icon: '/icons/crypto/tether.svg', nameKey: 'usdt', networkKey: 'erc20', accent: '#50AF95' },
  { id: 'usdt_ton', symbol: 'USDT', icon: '/icons/crypto/tether.svg', nameKey: 'usdt', networkKey: 'tonNetwork', accent: '#50AF95' },
  { id: 'ton', symbol: 'TON', icon: '/icons/crypto/ton-toncoin-logo.svg', nameKey: 'ton', networkKey: 'tonNetwork', accent: '#0098EA' },
];

export const DEFAULT_CRYPTO_CURRENCY = 'btc';

export default function CryptoCurrencyPicker({ value, onChange, className = '' }) {
  const { t } = useTranslation();

  return (
    <section
      className={['rounded-home-16 bg-glass-8 border border-border-default p-3', className]
        .filter(Boolean)
        .join(' ')}
      aria-label={t('plans.cryptoPicker.aria')}
    >
      <div className="mb-3 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="font-sans font-semibold text-[13px] leading-[15px] text-text-primary">
            {t('plans.cryptoPicker.title')}
          </p>
          <p className="mt-1 font-sans font-medium text-[10px] leading-[12px] text-text-primary opacity-[0.48]">
            {t('plans.cryptoPicker.subtitle')}
          </p>
        </div>
        <span className="shrink-0 rounded-full border border-accent-orange-start/60 px-2 py-1 font-sans font-semibold text-[9px] leading-[10px] text-accent-orange-start">
          P4Y
        </span>
      </div>

      <div className="grid grid-cols-2 gap-2">
        {CRYPTO_CURRENCY_OPTIONS.map((option) => {
          const isSelected = value === option.id;
          return (
            <button
              key={option.id}
              type="button"
              aria-pressed={isSelected}
              onClick={() => onChange(option.id)}
              className={[
                'min-h-[58px] rounded-home-12 border px-3 py-2 text-left',
                'bg-glass-16 transition-colors',
                isSelected ? 'border-accent-orange-start' : 'border-transparent',
              ].join(' ')}
            >
              <div className="flex items-center gap-2">
                <span
                  className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full"
                  style={{ backgroundColor: option.accent }}
                  aria-hidden="true"
                >
                  <img src={option.icon} alt="" className="h-8 w-8 rounded-full object-contain" />
                </span>
                <span className="min-w-0">
                  <span className="block font-sans font-semibold text-[12px] leading-[14px] text-text-primary">
                    {t(`plans.cryptoPicker.names.${option.nameKey}`)}
                  </span>
                  <span className="block font-sans font-semibold text-[10px] leading-[12px] text-text-primary opacity-[0.48]">
                    {t(`plans.cryptoPicker.networks.${option.networkKey}`)}
                  </span>
                </span>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}
